export enum ApiCalendarProviders {
  system = "system",
  google_calendar = "google_calendar",
}

export enum ApiConferenceProviders {
  google_meet = "google_meet",
  zoom = "zoom",
}

export interface ApiCalendar {
  id: number;
  title: string;
  timezone: string;
  is_default: boolean;
  provider: ApiCalendarProviders;
  conference_provider: string | null;
  conference_providers: ApiConferenceProviders[];
}
